import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-grid">
        <div className="about-image-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_collective-build-1/artifacts/x1oho0fp_iStock-2203784055.jpg" 
            alt="Team success"
            className="about-image"
          />
        </div>
        <div className="about-content-wrapper">
          <div className="about-container">
            <h2 className="section-title">About The R6™ Collective</h2>
            <div className="about-content">
              <p className="about-text">
                The R6™ Collective was founded on a simple premise: all organizations deserve access to comprehensive talent solutions—from foundational to strategic talent expertise.
              </p>
              <p className="about-text">
                Our team brings decades of combined experience from leading organizations across diverse sectors—from Fortune 100+, small and midsized businesses and franchises to civic organizations and nonprofits. We've built, scaled, and optimized complete talent systems for organizations at every stage of growth.
              </p>
              <p className="about-text">
                The Right 6™ Framework represents the synthesis of best practices and proven methodologies. It's a comprehensive approach designed for organizations ready to build agile and strategic talent solutions that drives their mission forward.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;